import { ViewStyle } from 'react-native';
import { DynaRowSectionStyles } from '../types';

const getDynaRowSectionStyles = (): DynaRowSectionStyles => ({
    packshotContainer: {} as ViewStyle,
    bannerCarouselContainer: {
        marginBottom: 25,
    },
});

export default getDynaRowSectionStyles;
